<script>
// Importing Line class from the vue-chartjs wrapper
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
// Exporting this so it can be used in other components
export default {
  extends: Line,
  mixins: [reactiveProp],
  data () {
    return {
      colors: [
        '#82ba3e',
        '#cb9a36',
        '#158f6f',
        '#257206',
        '#18148e',
        '#e3c640',
        '#2d4b10',
        '#2632dd',
        '#ec46ad',
        '#044ee3',
        '#6544ab',
        '#fa3d73',
        '#c172b2',
        '#0a2c67',
        '#499308',
        '#bc4839',
        '#562b73'
      ],
      // datacollection: {
      //   // Data to be represented on x-axis
      //   labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      //   datasets: [
      //     {
      //       label: 'Data One',
      //       backgroundColor: 'rgba(248, 121, 121, 0.3)',
      //       // backgroundColor: '#f87979',
      //       pointBackgroundColor: 'white',
      //       fillOpacity: 0.3,
      //       borderWidth: 1,
      //       pointBorderColor: '#249EBF',
      //       // Data to be represented on y-axis
      //       data: [40, 20, 30, 50, 90, 10, 20, 40, 50, 70, 90, 100]
      //     },
      //     {
      //       label: 'Data Two',
      //       backgroundColor: '#4044f8',
      //       pointBackgroundColor: 'white',
      //       borderWidth: 1,
      //       pointBorderColor: '#60bf5a',
      //       // Data to be represented on y-axis
      //       data: [23, 4, 1, 5, 76, 45, 32, 89, 12, 43, 12, 45]
      //     }
      //   ]
      // },
      // Chart.js options that controls the appearance of the chart
      datacollection: this.chartData,
      gradient: null,
      gradient2: null,
      options: {
        scales: {
          yAxes: [
            {
              id: 'y-axis-1',
              position: 'left',
              type: 'linear',
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: true
              }
            }
            // {
            //   id: 'y-axis-2',
            //   position: 'right',
            //   type: 'linear',
            //   ticks: {
            //     beginAtZero: true
            //   },
            //   gridLines: {
            //     display: false
            //   }
            // }
          ],
          xAxes: [ {
            gridLines: {
              display: false
            },
            ticks: {
              beginAtZero: true
            }
          }]
        },
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  mounted () {
    // const gradient = []
    // gradient[0] = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)
    // gradient[1] = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)
    // gradient[2] = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)

    // gradient[0].addColorStop(0, 'rgba(255, 0,0, 0.5)')
    // gradient[0].addColorStop(0.5, 'rgba(255, 0, 0, 0.25)')
    // gradient[0].addColorStop(1, 'rgba(255, 0, 0, 0)')

    // gradient[1].addColorStop(0, 'rgba(0, 231, 255, 0.9)')
    // gradient[1].addColorStop(0.5, 'rgba(0, 231, 255, 0.25)')
    // gradient[1].addColorStop(1, 'rgba(0, 231, 255, 0)')

    // gradient[2].addColorStop(0, 'rgba(0, 255, 0, 0.9)')
    // gradient[2].addColorStop(0.5, 'rgba(0, 255, 0, 0.25)')
    // gradient[2].addColorStop(1, 'rgba(0, 255, 0, 0)')

    // this.datacollection.datasets[0].backgroundColor = gradient[0]
    // this.datacollection.datasets[1].backgroundColor = gradient[1]
    // this.datacollection.datasets[2].backgroundColor = gradient[2]

    this.datacollection.datasets.forEach((val, index) => {
      val.borderColor = this.colors[index] || ''
      val.fill = false
    })

    this.renderChart(this.chartData, this.options)
  },
  methods: {
    drawChart () {
      // const gradient = []
      // gradient[0] = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)
      // gradient[1] = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)
      // gradient[2] = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)

      // gradient[0].addColorStop(0, 'rgba(255, 0,0, 0.5)')
      // gradient[0].addColorStop(0.5, 'rgba(255, 0, 0, 0.25)')
      // gradient[0].addColorStop(1, 'rgba(255, 0, 0, 0)')

      // gradient[1].addColorStop(0, 'rgba(0, 231, 255, 0.9)')
      // gradient[1].addColorStop(0.5, 'rgba(0, 231, 255, 0.25)')
      // gradient[1].addColorStop(1, 'rgba(0, 231, 255, 0)')

      // gradient[2].addColorStop(0, 'rgba(0, 255, 0, 0.9)')
      // gradient[2].addColorStop(0.5, 'rgba(0, 255, 0, 0.25)')
      // gradient[2].addColorStop(1, 'rgba(0, 255, 0, 0)')

      // this.datacollection.datasets[0].backgroundColor = gradient[0]
      // this.datacollection.datasets[1].backgroundColor = gradient[1]
      // this.datacollection.datasets[2].backgroundColor = gradient[2]

      this.datacollection.datasets.forEach((val, index) => {
        val.borderColor = this.colors[index] || ''
        val.fill = false
      })

      this.renderChart(this.chartData, this.options)
    }
  }
}
</script>
